<template>
  <div id="confirm-modal">
    <v-dialog
      transition="dialog-top-transition"
      width="340px"
      v-model="showModal"
    >
      <v-card height="auto">
        <v-toolbar color="primary" :title="title">
          <v-btn icon dark>
            <v-icon @click="cancelButtonClicked">mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="text-subtitle-1 text-center py-4">
            {{ this.subTitle }}
          </div>
        </v-card-text>
        <v-card-actions class="justify-space-between">
          <v-btn variant="text" @click="cancelButtonClicked">{{
            $t("users.table.deleteModal.cancelButton")
          }}</v-btn>
          <v-btn variant="text" @click="okButtonClicked">{{
            $t("users.table.deleteModal.okButton")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "ConfirmDeleteModal",
  props: {
    title: {
      type: String,
      required: true,
    },
    subTitle: {
      type: String,
      required: true,
    },
    showModalProp: {
      type: Boolean,
      default: false,
    },
    userId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      showModal: false,
    };
  },
  created() {
    this.showModal = true;
  },
  methods: {
    okButtonClicked() {
      this.emitter.emit("userDeleteConfirm", this.userId);
      this.emitter.emit("closeConfirmModal");
      this.emitter.emit("closeModal");
      this.emitter.emit("closePopper");
    },
    cancelButtonClicked() {
      this.emitter.emit('closeConfirmModal');
    },
  },
};
</script>

<style lang="scss" scoped></style>
